import React from 'react';
import { TextInput } from './TextInput';
import { Col, InputNumber } from 'antd';
interface WorkingPopulationMenProps {
	validate: () => Promise<void>;
	fieldName: string;
}

export const WorkingPopulationMen: React.FC<WorkingPopulationMenProps> = ({ fieldName, validate }) => {
	return (
		<Col xs={6}>
			<TextInput
				namePath={[fieldName, 'working_population_men']}
				title="Men"
				message={'Working population must be greater than 0'}
			>
				<InputNumber onChange={validate} min={0} />
			</TextInput>
		</Col>
	);
};
